import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { loadSectionTexts } from '../../utils/contentService';
import heroBg from '../../assets/imgs/hero-bg.png';
import heroBgMobile from '../../assets/imgs/hero-bg-mobile.jpg';

export default function HeroSection() {
  const { i18n } = useTranslation();
  const [texts, setTexts] = useState({});
  const [useMobileImage, setUseMobileImage] = useState(false);

  useEffect(() => {
    setTexts(loadSectionTexts('hero', i18n.language));
  }, [i18n.language]);

  useEffect(() => {
    const checkImageFit = () => {
      setUseMobileImage(window.innerWidth < 450);
    };

    checkImageFit();
    window.addEventListener('resize', checkImageFit);
    return () => window.removeEventListener('resize', checkImageFit);
  }, []);

  return (
    <section className="w-full bg-test flex items-center justify-center overflow-hidden min-[1300px]:py-8">
      <img
        src={useMobileImage ? heroBgMobile : heroBg}
        alt={texts.alt || ''}
        className="w-full h-auto max-w-full min-[1300px]:max-w-[90%] min-[1300px]:max-h-[85vh] min-[1300px]:object-contain"
      />
    </section>
  );
}
